export default {
      id: "icon-xs-gear-usage",
      viewBox: "0 -1 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-xs-gear",
      toString: function () {
        return this.url;
      }
    }